// extracted by mini-css-extract-plugin
export default {"enhancedAwardsContainer":"enhancedAwardsContainer--mp-oqlyt"};